import { useTranslation as e } from "../../i18n.mjs";
import { ToolbarSelect as t } from "../../components/content-controls/toolbar-select.mjs";
import { ToolbarSheetSelect as n } from "../../components/content-controls/toolbar-sheet-select.mjs";
import { isImageSelected as r } from "../image-extension/utils/is-image-selected.mjs";
import { TextAlignEnum as i } from "./text-align-enum.mjs";
import { getCurrentTextAlignValue as a, getTextAlignValues as o } from "./utils/text-align.mjs";
import { useEditorState as s } from "@tiptap/react";
import { useMemo as c } from "react";
import { jsx as l } from "react/jsx-runtime";
import { AlignCenterIcon as u, AlignJustifyIcon as d, AlignLeftIcon as f, AlignRightIcon as p } from "@systemeio/icons";
//#region src/extensions/text-align-extension/use-text-align-extension-toolbar.tsx
var m = (m) => {
	let { t: h } = e(), g = s({
		editor: m,
		selector: ({ editor: e }) => ({
			isEditable: e?.options.editable ?? !1,
			textAlign: a(e),
			isImageSelected: r(e)
		})
	}), _ = g?.textAlign ?? i.Left, v = !g?.isEditable || !!g?.isImageSelected;
	return c(() => {
		let e = () => {
			switch (_) {
				case i.Right: return /* @__PURE__ */ l(p, {});
				case i.Center: return /* @__PURE__ */ l(u, {});
				case i.Justify: return /* @__PURE__ */ l(d, {});
				case i.Left:
				default: return /* @__PURE__ */ l(f, {});
			}
		}, r = (e) => {
			if (!m) return null;
			m.chain().focus().setTextAlign(e).run();
		};
		return {
			toolbarRender: /* @__PURE__ */ l(t, {
				disabled: v,
				label: h("text_align"),
				onChange: r,
				options: o(),
				value: _,
				children: e()
			}),
			sheetRender: /* @__PURE__ */ l(n, {
				disabled: v,
				icon: e(),
				label: h("text_align"),
				onChange: r,
				options: o(),
				value: _
			})
		};
	}, [
		m,
		v,
		_,
		h
	]);
};
//#endregion
export { m as useTextAlignExtensionToolbar };
